"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zh_TW_1 = __importDefault(require("date-fns/locale/zh-TW")); //
const datezhTW = {
    name: 'zh-TW',
    locale: zh_TW_1.default
};
exports.default = datezhTW;
